<template>
  <div class="ordernumber">
    <span class="small">TV-Bestellnr.</span>
    <span class="number">{{ $attrs.ordernumber }}</span>
    <span class="small">{{ bookableFrom }} - {{ bookableTo }}</span>
  </div>
</template>

<script>

export default {
  name: 'OrderNumber',
  data() {
    return {
      months: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
    }
  },
  computed: {
    bookableFrom() {
      let date = new Date(this.fixDateString(this.$attrs.bookablefrom.date));
      return this.months[date.getMonth()] + " " + (date.getYear() - 100);
    },
    bookableTo() {
      let date = new Date(this.fixDateString(this.$attrs.bookableto.date));
      return this.months[date.getMonth()] + " " + (date.getYear() - 100);
    },
  },
  methods: {}
}
</script>

<style lang="scss">
</style>